module.exports = __webpack_public_path__ + "media/assets/good_at/elixir-4573f4d9f7873ce97150d7d67e467f13.png";